import React from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';

interface Props {
    tabs: Tab[];
    activeTab: number;
    onTabClicked?: (id: number) => void;
}

interface Tab {
    id: number;
    title: string;
    content: React.ReactElement;
    visible?: boolean;
}

const PrometTabs = (props: Props) => {

    const isTabActive = (tab: number) => {
        return props.activeTab === tab;
    }

    const onTabClicked = (tab: number) => {
        if (props.onTabClicked) {
            props.onTabClicked(tab);
        }
    }

    const filteredTabs = props.tabs.filter(tab => tab.visible !== false);

    return (
        <>
            <Nav tabs>
                {
                    filteredTabs.map((tab: Tab) => (
                        <NavItem key={tab.id}>
                            <NavLink className={classnames({ active: isTabActive(tab.id) })} onClick={() => onTabClicked(tab.id)}>
                                {tab.title}
                            </NavLink>
                        </NavItem>
                    ))
                }
            </Nav>

            <TabContent activeTab={props.activeTab}>
                {
                    filteredTabs.map((tab: Tab) => (
                        <TabPane key={tab.id} tabId={tab.id}>
                            {tab.content}
                        </TabPane>
                    ))
                }
            </TabContent>
        </>
    )
}

export default PrometTabs;
